import { CloseIcon, DownloadIcon, IconReload } from '@/assets/images';
import { useMediaGroupProgress } from '@/features/chats/sub-features/media/viewmodel/useMediaGroupProgress';
import { formatBytes } from '@/shared/utils/mediaUtils';
import PropTypes from 'prop-types';
import ProgressBar from './ProgressBar';
import { AppText } from '@/components';

const GroupProgressLoader = ({ messages }) => {
   const {
      isProgressing,
      isRetryable,
      isDownloadable,
      progress,
      totalFileSize,
      batchDownload,
      batchCancel,
      batchRetry,
   } = useMediaGroupProgress(messages);

   if (!isProgressing && !isRetryable && !isDownloadable) return null;

   const fileSizeFormatted = formatBytes(totalFileSize, 0).toLowerCase();

   const handleProgressClick = () => {
      if (isProgressing) {
         batchCancel();
      }

      if (isRetryable) {
         batchRetry();
      }

      if (isDownloadable) {
         batchDownload();
      }
   };

   return (
      <div className="groupProgressOverlay">
         <button
            className={`${!isProgressing ? 'group-progress-capsule' : ''} ct-flex ct-aiCenter ct-gap8`}
            onClick={handleProgressClick}
         >
            {isProgressing && (
               <div className="fileInprogess ct-flexCenter">
                  <ProgressBar progress={progress} />
                  <i className="ct-icon">
                     <CloseIcon />
                  </i>
               </div>
            )}

            {isRetryable && (
               <div className="fileInprogess ct-flexCenter">
                  <i className="ct-icon">
                     <IconReload />
                  </i>
               </div>
            )}

            {isDownloadable && (
               <div className="fileInprogess ct-flexCenter">
                  <i className="ct-icon">
                     <DownloadIcon />
                  </i>
               </div>
            )}

            {!isProgressing && <AppText as="span">{fileSizeFormatted}</AppText>}
         </button>
      </div>
   );
};

GroupProgressLoader.propTypes = {
   messages: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default GroupProgressLoader;
